import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import { flexColumn } from '../../Styles';
import { IDashboardSectionProps } from '../DashboardSection/DashboardSection.types';

const DashboardSectionTitle = styled.span``;

const DashboardSectionDescription = styled.span``;

const DashboardSectionContainer = styled.div`
  padding-top: 20px;
  width: 100%;
  ${flexColumn}
`;

export const BaseDashboardSection: FunctionComponent<IDashboardSectionProps> = props => {
  const { children, title, description, className } = props;

  return (
    <DashboardSectionContainer className={className}>
      <DashboardSectionTitle>{title}</DashboardSectionTitle>
      <DashboardSectionDescription>{description}</DashboardSectionDescription>
      {children}
    </DashboardSectionContainer>
  );
};

export default BaseDashboardSection;
